import React from 'react';

const EmaIntersectsFirstCandleDocs = (
    <>
        If the ema('s) intersects the low of the first candle of the day if long, or
        if the ema('s) intersects the high of the first candle of the day if short,
        cancel the setup.
        <br></br>
        <br></br>
        Ex: You have a bounce off ema setup for the 8 5 min ema. You believe that if
        ema breaks the low of the 15 minute regular-session opening candle, that you
        should not go long anymore, and cancel the setup. That is the goal of this filter.
        <br></br>
        params:
        <p>
            <b>Below, Above, High, Low:</b> configures what conditions must be met in terms of the candle to filter.
            For example, if the candleDuration is 2, Below is selected, and High is selected,
            we will only allow trades that occur when the current price is below open 2 minute candle High. If Low was
            selected instead of High,
            we will only allow trades below the candle low. If Above and High are selected, only trades above the 2
            min candle high will pass the filter. Lastly, if Above and Low are selected, only trades above 2 min candle
            low
            will pass.
        </p>
        <br></br>
        <b>first candle Duration: </b>
        <br></br>
        the duration of the first regular-session candle that you would like to track.
        <br></br>
        <b>ema candle Duration:</b>
        <br></br>
        the length of the minute of the ema you'd like to track. So if you were
        tracking the 8 5min ema, the candle duration would be 5. Similarly with 21
        5min ema, the candle duration would be 21.
        <br></br>
        <b>periods:</b>
        <br></br>
        the period of the ema you'd like to track. So if you were tracking the 8
        5min ema, the period would be 8. Similarly with 21 5min ema, the candle
        duration would be 21. If you would like to track multiple EMA's
        simultaneously, provide the emas in a comma separated list. So if you'd like
        to trade both the 8 and 21 5 min ema's at once, periods would be 8,21
        <br></br>
        <b>associate with ema setup:</b>
        <br></br>
        this parameter is for if you are running with an ema setup of the same
        minute as the filter. You can choose to associate the filter to the ema. So
        that if you are trading the 8 and 21 ema, the fact that the 8 ema crosses
        the first candle, does not mean that the 21 ema setup will cancel. If this
        is unchecked, the the setup will cancel upon any break of the first candle
        for any ema provided.
        <p>NOTE:</p>
        <p>
            The app can remain active outside regular equity market hours, but this EMA
            calculation is still based on regular-session candles unless the tactic
            explicitly uses pre-market or post-market data. Other platforms may show a
            different EMA if they include extended-hours candles.
        </p>
    </>
);
export default EmaIntersectsFirstCandleDocs;
